<template>
	<div class="comment-details ">
		<!-- ahi -->
		<div class="comment-details-item">
			<div class="comment-details-item-box">
				<div class="details-title-breath">
					<div class="details-title">
						<div class="details-title-icon">
							<img v-if="breathIndexAHI >= 30" src="../../../assets/img/report_icon_notice_d@2x.png" alt="" srcset="" />
							<img v-if="breathIndexAHI >= 5 && breathIndexAHI < 30"
								src="../../../assets/img/report_icon_notice_Yellow.png" alt="" srcset="" />
							<img v-if="breathIndexAHI < 5" src="../../../assets/img/report_icon_good_d@2x.png" alt="" srcset="" />
						</div>
						<div style="margin-right:6px;">呼吸异常指数</div>
						<div class="details-title-num color1890ff" v-if="breathIndexAHI < 5">{{ breathIndexAHI }}</div>
						<div class="details-title-num colorFFB971" v-if="breathIndexAHI >= 5 && breathIndexAHI < 30">{{ breathIndexAHI
						}}</div>
						<div class="details-title-num colorFF7186" v-if="breathIndexAHI >= 30">{{ breathIndexAHI }}</div>
						<div class="comment-box ">
							<div class="tooltip">
								<img style="width:20px;height:20px;"
									src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account/wenhaoIcon.png"
									alt="" />
								<div class="tooltiptext" style="top: -360px;">
									<div class="ahi-title">
										呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，在一定程度上反应使用者呼吸的大概情况，这个指数越大，您在呼吸方面发生异常的风险越高。如果需要更精准的监测，可以使用我们的QS-600产品，数据仅供参考，如果有需要可以去专业的医疗机构寻求帮助。
									</div>
									<div class="ahi-item" v-html="'指数<5 是健康'"></div>
									<div class="ahi-item ahi-item2" v-html="'5≤指数<15 疑似低风险'"></div>
									<div class="ahi-item ahi-item2" v-html="'15≤指数<30 疑似中风险'"></div>
									<div class="ahi-item ahi-item3" v-html="'指数≥30 疑似高风险'"></div>
								</div>
							</div>
						</div>

					</div>
					<div>
						<div class="ml24 details-consult">
							{{ breathIndexReferenceValue }}
						</div>
					</div>
				</div>
				<div class="details-title ml24" v-if="continuityDaysAHI != 0">
					<div>连续</div>
					<div class="details-title-num colorFFB971" v-if="breathIndexAHI >= 5 && breathIndexAHI < 30">{{
						continuityDaysAHI }}</div>
					<div class="details-title-num" v-if="breathIndexAHI >= 30">{{ continuityDaysAHI }}</div>
					<div>{{ continuityDaysAHIText }}</div>
				</div>

				<div class="detailed-inter" :style="{ height: isSowDetailRead ? '100%' : '45px' }"
					v-if="detailedInterBreathData.length > 0">
					<div class="detailed-inter-title" v-if="breathIndexAHI >= 5" @click="changeShowDetailBox">
						<div>详细解读</div>
						<img v-if="isSowDetailRead" src="../../../assets/img/icon_unscramble_up_h@2x.png" alt="" srcset="" />
						<img v-else src="../../../assets/img/icon_unscramble_down_h@2x.png" alt="" srcset="" />
					</div>
					<div class="detailed-inter-line"></div>
					<div>
						<div class="detailstr-circle" v-for="(ktem, index) in detailedInterBreathData" :key="index + 'w'">
							{{ ktem }}
						</div>
						<div class="advice-item" v-for="(ytem, index) in detailedInterBreathDataAdvice" :key="index + 'e'">
							<img :src="require('../../../assets/img/' + ytem.imageName + '.png')" alt="" srcset="" />
							<div v-html="ytem.adviceText"></div>
						</div>
						<div class="detailstr-circle" v-if="lastTextAHI != ''">
							{{ lastTextAHI }}
						</div>
					</div>
				</div>
				<div class="breath-thing" v-if="breathAHINum > 0">
					<div class="breath-thing-title">
						<div>呼吸事件</div>
						<div>次数</div>
						<!-- <div>平均时长</div> -->
					</div>
					<div class="detailed-inter-line"></div>
					<div class="breath-thing-title">
						<div>{{ breathAHIName }}</div>
						<div>{{ breathAHINum }}</div>
						<!-- <div>{{ breathAHITime }}</div> -->
					</div>
				</div>
				<div class="detailed-inter-line" v-if="breathAHIChangeNum != 0 && breathAHIChangeNum && breathAHIChangeNum != null && breathAHIChangeNum != undefined"></div>
				<div class="breath-title" v-if="breathAHIChangeNum != 0 && breathAHIChangeNum && breathAHIChangeNum != null && breathAHIChangeNum != undefined">
					<div class="breath-title-left">呼吸异常事件</div>
					<div class="breath-title-right">共{{ breathAHIChangeNum }}次</div>
				</div>
				<div id="myChartsAHI1" :style="{
					width: '100%',
					height: '60px',
					margin: '10px auto',
					zoom: `${1 / zoom}`,
					transform: `scale(${zoom})`,
					transformOrigin: '0 0',
				}" v-if="breathAHIChangeNum != 0 && breathAHIChangeNum && breathAHIChangeNum != null && breathAHIChangeNum != undefined"></div>
				<div class="detailed-inter-line" v-if="abnData.webUrlList && abnData.webUrlList.length > 0"></div>
				<div class="myCharts dxhxEvent" v-if="abnData.webUrlList && abnData.webUrlList.length > 0">
					<div class="breath-title">
						<div class="breath-title-left">典型呼吸异常事件</div>
						<div class="breath-title-right" @click="showModalHH">
							<div>看不懂图</div>
							<img src="../../../assets/img/report_icon_details_d@2x.png" alt="" srcset="" />
						</div>
					</div>
					<div class="AHI-position" v-if="dialogVisibleIn">
						<div class="AHI-position-dom">
							<span style="font-size: 14px; color: #000000">呼吸深度图&nbsp;</span>
							<span style="font-size: 12px; color: #999999">&nbsp;反应呼吸深度，波的幅度越高，呼吸越深，波的幅度越低，呼吸越浅</span>
							<span style="font-size: 20px; color: #8c8c8c; float: right" @click="showModalHH">x</span>
							<div style="display: flex;">
								<img src="../../../assets/comment1.png" style="width: 50%; padding: 1% 1% 1% 0" />
								<img src="../../../assets/comment2.png" style="width: 50%; padding: 1% 0 1% 1%" />
							</div>
						</div>
					</div>
					<!-- 轮播部分 -->
					<div class="dxlbWrap" v-if="abnData.webUrlList && abnData.webUrlList.length > 0">
						<el-carousel height="110px" trigger="click" :autoplay="true" :interval="5000" ref="abnormal"
							indicator-position="outside" arrow="never" style="width: 100%" @change="carouselChage">
							<el-carousel-item v-for="(item, index) in abnData.webUrlList" :key="index">
								<div style="display: flex;">
									<div class="bt" style="color: rgba(165, 169, 188, 1);">
										发生于<span class="ml5" style="color: #1890ff">{{ item.time }}</span>
									</div>
									<div class="bt" style="margin-left: 10px; color: rgba(165, 169, 188, 1);">
										持续<span class="ml5" style="color: #1890ff">{{ item.duration + '秒' }}</span>
									</div>
								</div>
								<div class="imgWrap">
									<!-- <img class="img" :src="item.url" alt="" /> -->
									<div id="dxyc0" style="width: 377px;height:75px;" v-if="index == 0"></div>
									<div id="dxyc1" style="width: 377px;height:75px;" v-if="index == 1"></div>
									<div id="dxyc2" style="width: 377px;height:75px;" v-if="index == 2"></div>
									<div id="dxyc3" style="width: 377px;height:75px;" v-if="index == 3"></div>
									<div id="dxyc4" style="width: 377px;height:75px;" v-if="index == 4"></div>
									<div id="dxyc5" style="width: 377px;height:75px;" v-if="index == 5"></div>
									<div id="dxyc6" style="width: 377px;height:75px;" v-if="index == 6"></div>
								</div>
							</el-carousel-item>
							<!-- 如果图片为两张时，多补两张图 -->
							<!-- <el-carousel-item v-if="abnData.sliceNum == 2">
								<div class="bt">
									发生于<span class="ml5" style="color: #1890ff">{{abnData.webUrlList[0].time}}</span>
								</div>
								<div class="imgWrap">
									<img class="img" :src="abnData.webUrlList[0].url" alt="" />
								</div>
							</el-carousel-item>

							<el-carousel-item v-if="abnData.sliceNum == 2">
								<div class="bt">
									发生于<span class="ml5" style="color: #1890ff">{{abnData.webUrlList[1].time}}</span>
								</div>
								<div class="imgWrap">
									<img class="img" :src="abnData.webUrlList[1].url" alt="" />
								</div>
							</el-carousel-item> -->
							<!-- 如果图片为两张时，多补两张图end -->
						</el-carousel>

						<div class="btnWrap" v-if="abnData.sliceNum != 1">
							<div class="left-btn-abn">
								<img src="../../../assets/flipLeft.png" @click="pre" alt="" />
							</div>
							<div class="right-btn-abn">
								<img src="../../../assets/flipRight.png" @click="next" alt="" />
							</div>
						</div>
						<div class="num" v-if="abnData.sliceNum != 1">0{{ currentCar }} / 0{{ abnData.sliceNum }}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 吸呼比 -->
		<div class="comment-details-item">
			<div class="comment-details-item-box">
				<div class="details-title" v-if="normalFlaginExRatio == 1">
					<div class="details-title-icon">
						<img src="../../../assets/img/report_icon_notice_d@2x.png" alt="" srcset="" />
					</div>
					<div class="details-title-num" style="margin-right:6px;">80%</div>
					<div>以上的吸呼比落在非正常区间</div>
				</div>
				<div class="details-title" v-if="normalFlaginExRatio == 0">
					<div class="details-title-icon">
						<img src="../../../assets/img/report_icon_good_d@2x.png" alt="" srcset="" />
					</div>
					<div style="margin-right:5px">吸呼比</div>
					<div class="details-title-num" style="color:#1890ff;" v-if="isHave_xhb">正常</div>
				</div>

				<div class="details-title" v-if="normalFlaginExRatio == 2 && continuityDaysBreathNum != 0">
					<div class="details-title-icon">
						<img src="../../../assets/img/report_icon_notice_d@2x.png" alt="" srcset="" />
					</div>
					<div>连续</div>
					<div class="details-title-num">{{ continuityDaysBreathNum }}</div>
					<div>晚吸呼比集中在非正常区间</div>
				</div>
				<!-- <div class="detailed-inter" :style="{ height: isSowDetailRead ? '100%' : '45px' }" v-if="detailedInterBreathData.length > 0 && !normalFlaginExRatio"> -->
				<!-- <div class="detailed-inter" :style="{ height: isSowDetailRead ? '100%' : '45px' }" v-if="detailedInterBreathData.length > 0"> -->
				<div class="detailed-inter" :style="{ height: isSowDetailRead ? '100%' : '45px' }">
					<div class="detailed-inter-title" @click="changeShowDetailBox">
						<div>详细解读</div>
						<img v-if="isSowDetailRead" src="../../../assets/img/icon_unscramble_up_h@2x.png" alt="" srcset="" />
						<img v-else src="../../../assets/img/icon_unscramble_down_h@2x.png" alt="" srcset="" />
					</div>
					<div class="detailed-inter-line"></div>
					<div>
						<div class="detailstr-circle" v-for="(ktem, index) in breathScaleData" :key="index + 'u'">
							{{ ktem }}
						</div>
						<div class="advice-item" v-for="(ytem, index) in breathScaleDataAdvice" :key="index + 'i'">
							<img :src="require('../../../assets/img/' + ytem.imageName + '.png')" alt="" srcset="" />
							<div v-html="ytem.adviceText"></div>
						</div>
						<div class="detailstr-circle" v-if="lastTextBreath != ''">
							{{ lastTextBreath }}
						</div>
					</div>
					<!-- <div class="detailed-inter-line"></div> -->
				</div>


				<!-- 柱状图有问题的指标共用 -->
				<div class="mt10">
					<div class="draw_canvas-title clear">
						<div class="draw_canvas-title-item" v-for="(item, index) in inExRatioData" :key="index + 'q'"
							@click="changeActivePie(index)">
							<div class="title-item-pic" :class="{ 'active-flag-pic': index == activePicFlage }"></div>
							<div>{{ item.date }}</div>
						</div>
					</div>
					<div class="colPicWrap draw_canvas" style="margin-top:0" v-show="isHave_xhb">
						<div class="colTop draw_canvas">
							<div class="topIcon draw_canvas"></div>
							<div class="topTit draw_canvas">参考范围</div>
						</div>

						<div class="colChartWrap draw_canvas">
							<div id="myCharts_xhb" style="height: 170px; margin: 0 auto"></div>
						</div>

					</div>
					<div class="content-chart pd0" style="background:#F3F4F7" v-show="!isHave_xhb">
						<div class="noVal mt15" style="height: 200px;color:#9094A6;">暂无吸呼比</div>
					</div>
				</div>
				<!-- 柱状图end -->

			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
export default {
	props: {
		score: 0,
		detailsData: {},
		dataTitleList: null,
		beginTime: "",
		endTime: "",
		sleepEffect: null,
		getBedTime: "",
		leaveBedTime: "",
		outEnd: false,
		outLeave: false,

		searchTime: "",
		searchBedId: "",
		oneDayData: {}, //getSleepReportOneDay接口数据
	},
	data() {
		return {
			detailedInterBreathData: [],
			breathIndexAHI: 0,
			breathIndexReferenceValue: "参考值：< 5",
			detailedInterBreathDataAdvice: [],
			lastTextAHI: "",
			continuityDaysAHI: "",
			continuityDaysAHIText: "",
			breathAHIName: "",
			breathAHINum: "",
			breathAHITime: "",
			breathAHIChangeNum: 0,
			breathScaleData: [],
			breathScaleDataAdvice: [],
			continuityDaysBreathNum: "",
			lastTextBreath: "",
			myChartsAHI: null,
			dialogVisibleIn: false,
			abnData: {
				// 轮播图数据
				webUrlList: [],
			},
			currentCar: "1",
			everyHeight: [],
			everyOpacityArr: [],
			posAb_Y_arr: [],
			inExRatioData: [],
			activePicFlage: 0,
			isSowDetailRead: true,
			normalFlaginExRatio: true,
			zoom: null,
			isHave_xhb: true, //是否显示吸呼比柱状图

			everyHei_perArr: [],
			everyHei_offsetX: 0,
			everyHei_nowInd: 0,
		};
	},
	mounted() {
		// this.waterFall();
		this.getWebOneDayReport();

		this.$nextTick(() => {
			// zoom.value = document.body.style.zoom;
		});
	},
	methods: {
		// 吸呼比柱状图未落在正常区间
		breathScale(data) {
			let myCharts_xhb = this.$echarts.init(document.getElementById('myCharts_xhb'));
			console.log(data)
			if (data.data.length == 0) {
				this.isHave_xhb = false
			} else {
				this.isHave_xhb = true
			}

			let everyOpacityArr = this.getBarMaxAlphaArr(data.data); //吸呼比柱状图透明度
			console.log(everyOpacityArr)


			// 参数获取
			let name = this.name || "";
			let xAxisArr = data.xaxis;
			let seriesArr = data.data || [];
			if (seriesArr.length > 20) {
				let tempSeriesArr = JSON.parse(JSON.stringify(seriesArr));
				for (let i = 0; i < seriesArr.length; i++) {
					let item = seriesArr[i];
					tempSeriesArr[i] = {
						value: item,
						itemStyle: {
							normal: {
								color: '#4D8EF7',
								opacity: everyOpacityArr[i]
							},
						},
					};
				}
				seriesArr = tempSeriesArr;
			}

			// 设置 tooltip
			let tooltip = {
				trigger: "axis",
				backgroundColor: "#FFFFFF",
				borderColor: "rgba(24, 144, 255, 0.6)",
				borderWidth: 1,
				borderRadius: 5,
				textStyle: {
					color: "#8c8c8c",
				},
				confine: true,
				formatter: function (val) {
					if (!val || val.length == 0) {
						return;
					}
					console.log(val)
					let value = val[0].value;
					let sty = '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>'
					if (value) {
						let res = Math.floor(value * 100);
						return sty + res + '%吸呼比' + '<br/>' + '集中在' + val[0].axisValue;
					} else {
						return sty + '0%吸呼比' + '<br/>' + '集中在' + val[0].axisValue;
					}
				},
			};

			let yFormatter = function (val) {
				return Math.floor(val * 100) + '%';
			};

			// let singleW = (DefineTool.width - 42 - 28) / xAxisArr.length;
			// let needX1 = 42 + 7 * singleW - singleW / 2.0;
			// let needX2 = 42 + 15 * singleW - singleW / 2.0 - 6.0;

			let markArea = {
				//  提示图表标域，常用于标记图表中某个范围的数据
				silent: true,
				itemStyle: {
					color: 'rgba(77,142,247,0.05)',
					borderColor: "#4D8EF7",
					borderWidth: 1,
					borderType: "dashed",
				},
				data: [
					[
						{ xAxis: "0.8", x: 137 },
						{ xAxis: "1.5", x: 245 },
						// { x: 257 },
						// { x: 507 },
					],
				],
			};

			let option = {
				// Tip
				tooltip: tooltip,
				// x 轴配置项
				xAxis: {
					data: xAxisArr,
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: "#A5A9BC",
						},
					},
					axisLabel: {
						textStyle: {
							color: "#A5A9BC", //坐标的字体颜色
						},
						formatter: function (val) {
							if (val == '0.5' || val == '1' || val == '1.5' || val == '2' || val == '2.5' || val == '0.1') {
								return val;
							}
							return '';
						},
						interval: 0,
					},
				},
				yAxis: {
					// y 轴配置项
					axisTick: {
						show: false,
					},
					axisLine: {
						show: false, // 显示y轴的线
						lineStyle: {
							color: "#A5A9BC",
						},
					},
					axisLabel: {
						formatter: yFormatter,
						textStyle: {
							color: "#A5A9BC", //坐标的字体颜色
						},
					},
				},
				// 内边距
				grid: {
					x: 42,
					y: 20,
					x2: 16,
					y2: 20,
				},
				// 系列的设置：绘制什么类型的图表type、数据在这里展示
				series: [
					{
						name: name,
						type: "bar", // 图标类型的设置
						data: seriesArr, // 图标的数据
						color: "#1890FF",
						itemStyle: {
							normal: {
								barBorderRadius: [5, 5, 0, 0],
								color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: "#C394FE" },
									{ offset: 1, color: "#B84DF7" },
								]),
							},
						},
						markArea: markArea,
						barWidth: 12,
					},
				],
			};
			myCharts_xhb.setOption(option);

		},

		carouselChage(data) {
			console.log(data);
			this.currentCar = data + 1;
			// 如果图片为两张时，多补两张图

			let index = 0;
			let breaList = this.oneDayData.breathIndexList;
			for (let i = 0; i < breaList.length; i++) {
				if (breaList[i].indexName == "AHI") {
					index = i;
				}
			}
			console.log(index);
			console.log(this.oneDayData.breathIndexList[index]);
			console.log(this.oneDayData);
			if (
				this.oneDayData.breathIndexList[index].extendData.breathExTypicalEventVo
					.sliceNum == 2
			) {
				if (data == 2) {
					this.currentCar = 1;
				} else if (data == 3) {
					this.currentCar = 2;
				}
			}
		},
		changeActivePie(data) {
			this.activePicFlage = data;
			this.breathScale(this.inExRatioData[this.activePicFlage].inExRatioData);
		},
		next() {
			this.$refs.abnormal.next();
			// if(this.currentPage >= this.abnLength) this.currentPage = 1;
			// else this.currentPage++;
		},
		pre() {
			this.$refs.abnormal.prev();
			// if(this.currentPage <= 1) this.currentPage = this.abnLength;
			// else this.currentPage--;
		},
		showModalHH() {
			console.log(12);
			this.dialogVisibleIn = !this.dialogVisibleIn;
			console.log(this.dialogVisibleIn);
		},
		// 改变显示详细解读状态
		changeShowDetailBox() {
			this.isSowDetailRead = !this.isSowDetailRead;
		},
		getWebOneDayReport() {
			let params = {
				bedId: this.searchBedId,
				date: this.searchTime,
				// 有呼吸异常指数
				// bedId: 1220,
				// date: '2023-06-28',

				// 有吸呼比柱状图数据的
				// bedId: 1057,
				// bedId: 1253,
				// date: "2022-12-31",
				reportType: 0,
			};
			this.$get(
				"/api/v3/report/getWebOneDayReport",
				params,
				(res) => {
					if (res.code == 0) {
						console.log(res.data);
						this.changeSleepIndexData(res.data.breathIndexList);
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		changeSleepIndexData(breathIndexList) {
			console.log(breathIndexList);
			let resData = [];
			breathIndexList.forEach((item, index) => {
				if (item.indexName == "AHI") {
					if (!item.extendData) {
						return;
					}
					this.breathAHIName = item.extendData.breathEventVo.breathEvent;
					this.breathAHINum = item.extendData.breathEventVo.frequency;
					this.breathAHITime = item.extendData.breathEventVo.avgDuration;
					this.breathAHIChangeNum = item.extendData.breathExEventNewVo ? item.extendData.breathExEventNewVo.num : undefined;
					this.breathIndexAHI = item.indexVal;
					// 呼吸事件
					let hxsj = {
						xAxis: {
							data: item.extendData.breathExEventNewVo ? item.extendData.breathExEventNewVo.xtimeAxis : undefined, //X轴通用呼吸周期			//X轴通用呼吸周期
							min: "",
							max: "",
						},
						yAxis: {},
						series: {
							data: item.extendData.breathExEventNewVo ? item.extendData.breathExEventNewVo.data : [],
						},
					};
					this.getMyChartAHI("myChartsAHI1", hxsj, item.extendData.breathExEventNewVo ? item.extendData.breathExEventNewVo : undefined); // 呼吸事件

					this.$nextTick(() => {
						if (item.extendData.breathSliceDataList && item.extendData.breathSliceDataList.length > 0) {
							console.log("有典型异常呼吸事件");
							if (item.extendData.breathSliceDataList.length > 0) {
								for (let i = 0; i < item.extendData.breathSliceDataList.length; i++) {
									// console.log()
									let dxycData = item.extendData.breathSliceDataList[i].data;
									this.get_dxycThing("dxyc" + i, dxycData);
								}
							}
						}
					});
				} else {
					this.normalFlaginExRatio = item.normalFlag
				}

				console.log(item.normalFlag);

				if (item.indexName == "吸呼比") {
					if (item.normalFlag == 0) {
						this.breathScaleData.push(
							"吸呼比是指吸气时长和呼气时长的比值，一般情况下，正常人的吸呼比集中在0.8~1.5之间，您的吸呼比落在正常范围内，无需担心。"
						);
						this.continuityDaysBreathNum = item.continuityDays;
						if (item.extendData) {
							let xhData = item.extendData;
							this.breathScale(xhData);

							this.isHave_xhb = true;
						} else {
							this.isHave_xhb = false;
						}
					} else if (item.normalFlag == 1) {
						//睡眠指标详细解读一般超范围
						let xhData = item.extendData;
						this.breathScale(xhData);

						this.breathScaleData.push(
							"吸呼比是指吸气时长和呼气时长的比值，一般情况下，正常人的吸呼比集中在0.8~1.5之间"
						);
						this.breathScaleData.push(
							"平时注意锻炼身体，增强体质，预防感冒，尽量不睡高枕头，保持呼吸道的通畅，持续观察吸呼比变化"
						);
						this.continuityDaysBreathNum = item.continuityDays;
					} else if (item.normalFlag == 2) {
						//连续性
						this.inExRatioData = item.extendData;
						this.breathScale(item.extendData[this.activePicFlage].inExRatioData);

						this.continuityDaysBreathNum = item.continuityDays;
						this.breathScaleData.push(
							"吸呼比是指吸气时长和呼气时长的比值，一般情况下，正常人的吸呼比集中在0.8~1.5之间"
						);
						this.breathScaleData.push("建议您尝试如下改善：");
						this.breathScaleDataAdvice.push(
							{
								imageName: "zhentou",
								adviceText: "尽量不睡高枕头，保持呼吸道的通畅",
							},
							{
								imageName: "yanjiu",
								adviceText: "合理饮食，控制体重，远离烟酒",
							},
							{
								imageName: "ceshui",
								adviceText: "改变卧姿，尽量以侧卧进入睡眠",
							}
						);
						this.lastTextBreath =
							" 在尝试了上述方法后，您可以持续观察吸呼比的变化，如果超过6个月依然没有改善，可以去医院做个详细检查";
					}
				}

				if (item.indexName == "AHI") {
					// 2024-09-19 需求确定修改为 webUrlList 有值就展示，没有不展示
					this.abnData = item && item.extendData && item.extendData.breathExTypicalEventVo ? item.extendData.breathExTypicalEventVo : {
						webUrlList: [],
						// 轮播图数据
						webOssUrlList: [],
					};

					if (item.normalFlag == 1) {
						this.detailedInterBreathData = [];
						if (item.normalFlagAhi == 5) {
							this.detailedInterBreathData.push(
								"呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于5即具有呼吸异常低风险"
							);
							this.detailedInterBreathData.push(
								"建议您平时要预防感冒，戒烟戒酒，采用侧睡体位，尽量不睡高枕头，保持呼吸道的通畅，必要时配合药物治疗，持续观察呼吸异常指数变化"
							);
						} else if (item.normalFlagAhi == 15) {
							this.detailedInterBreathData.push(
								"呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于15小于30即具有呼吸异常中风险"
							);
							this.detailedInterBreathData.push(
								"请及时听从医生建议，必要时配合器械治疗，持续观察呼吸异常指数变化"
							);
						} else if (item.normalFlagAhi == 30) {
							this.detailedInterBreathData.push(
								"呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于30即具有呼吸异常高风险"
							);
							this.detailedInterBreathData.push(
								"请及时听从医生建议，必要时进行手术治疗，持续观察呼吸异常指数变化"
							);
						}
					} else if (item.normalFlag == 2) {
						this.detailedInterBreathData = [];
						if (item.normalFlagAhi == 5) {
							this.continuityDaysAHI = item.continuityDays;
							this.continuityDaysAHIText = "晚呼吸异常指数大于等于5";
							this.detailedInterBreathData.push(
								"呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于5即具有呼吸异常低风险"
							);

							this.detailedInterBreathData.push("建议您尝试如下改善：");
							this.detailedInterBreathDataAdvice = [
								{
									imageName: "ceshui",
									adviceText: "改变卧姿，尽量以侧卧进入睡眠",
								},
								{
									imageName: "zhentou",
									adviceText: "尽量不睡高枕头，保持呼吸道的通畅",
								},
								{
									imageName: "yanjiu",
									adviceText: "合理饮食，控制体重，远离烟酒",
								},
								{
									imageName: "yundong",
									adviceText: "适量运动，增强体质，预防感冒",
								},
							];
							this.lastTextAHI =
								" 在尝试了上述方法后，您可以持续观察呼吸异常指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查";
						} else if (item.normalFlagAhi == 15) {
							this.continuityDaysAHI = item.continuityDays;
							this.continuityDaysAHIText = "晚呼吸异常指数大于等于15";
							this.detailedInterBreathData.push(
								"呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于15小于30即具有呼吸异常中风险"
							);
							this.detailedInterBreathData.push("建议您尝试如下改善：");
							this.detailedInterBreathDataAdvice = [
								{
									imageName: "ceshui",
									adviceText: "改变卧姿，尽量以侧卧进入睡眠",
								},
								{
									imageName: "zhentou",
									adviceText: "尽量不睡高枕头，保持呼吸道的通畅",
								},
								{
									imageName: "yanjiu",
									adviceText: "合理饮食，控制体重，远离烟酒",
								},
								{
									imageName: "tqzl",
									adviceText: "必要时可选择经鼻正压通气治疗",
								},
							];
							this.lastTextAHI =
								" 在尝试了上述方法后，您可以持续观察呼吸异常指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查";
						} else if (item.normalFlagAhi == 30) {
							this.continuityDaysAHI = item.continuityDays;
							this.continuityDaysAHIText = "晚呼吸异常指数大于等于30";
							this.detailedInterBreathData.push(
								"呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于30即具有呼吸异常高风险"
							);
							this.detailedInterBreathData.push("建议您尝试如下改善：");
							this.detailedInterBreathDataAdvice = [
								{
									imageName: "ceshui",
									adviceText: "改变卧姿，尽量以侧卧进入睡眠",
								},
								{
									imageName: "zhentou",
									adviceText: "尽量不睡高枕头，保持呼吸道的通畅",
								},
								{
									imageName: "yanjiu",
									adviceText: "合理饮食，控制体重，远离烟酒",
								},
								{
									imageName: "tqzl",
									adviceText: "必要时可选择经鼻正压通气治疗",
								},
							];
							this.lastTextAHI =
								" 在尝试了上述方法后，您可以持续观察呼吸异常指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查";
						}
					}
				}
			});

			this.$forceUpdate();
		},

		//呼吸暂停和低通气图表
		getMyChartAHI(idName, theData, tempItem) {
			let tData = JSON.parse(JSON.stringify(theData));
			let tArr = tData.series.data;
			let nArr = [];
			for (let i = 0; i < tArr.length; i++) {
				let item = tArr[i];
				if (item != '-' && item & item > 0) {
					nArr.push(2);
				} else {
					nArr.push(item);
				}
			}
			tData.series.data = nArr;
			let data = JSON.parse(JSON.stringify(tData));
			console.log("getMyChartAHI", idName, data);
			var apnea = data.series.data; //呼吸暂停新加
			if (this.myChartAHI) {
				this.myChartAHI.dispose();
			}

			this.$nextTick(() => {
				this.myChartAHI = this.$echarts.init(document.getElementById(idName));
				console.log("getMyChartAHI", this.myChartAHI);
				var option2 = {
					tooltip: {
						backgroundColor: "rgba(255, 255, 255, 0.9)",
						borderColor: "rgba(24, 144, 255, 0.8)",
						// borderWidth: 1,
						borderRadius: 5,
						trigger: "item",
						position: function (point, params, dom, rect, size) {
							//其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
							var x = point[0];
							var y = point[1];
							var viewWidth = size.viewSize[0];
							var viewHeight = size.viewSize[1];
							var boxWidth = size.contentSize[0];
							var boxHeight = size.contentSize[1];
							var posX = 0; //x坐标位置
							var posY = 0; //y坐标位置

							if (x < boxWidth) {
								//左边放不开
								posX = 5;
							} else {
								//左边放的下
								posX = x - boxWidth;
							}

							if (y < boxHeight) {
								//上边放不开
								posY = 5;
							} else {
								//上边放得下
								posY = y - boxHeight;
							}
							return [posX, posY];
						},
						formatter: function (params) {
							if (params.data != 0) {
								let needStr1 = "<div style='display: flex;'>" + "<div style='color: rgba(24, 144, 255, 1); margin-right: 3px;'>" + data.xAxis.data[params.dataIndex] + "</div>" + '发生' + "<div style='color: rgba(255, 113, 134, 1);'>" + tempItem.duration[params.dataIndex].length + "</div>" + '次呼吸暂停' + "</div>";
								let needStr = needStr1;
								for (let i = 0; i < tempItem.duration[params.dataIndex].length; i++) {
									let item = tempItem.duration[params.dataIndex][i];
									if (tempItem.duration[params.dataIndex].length == 1) {
										needStr = needStr + "<div style='display: flex; align-items: center'>" + "<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:10px;height:10px;background-color:rgba(185, 221, 255, 1);'></span>" + '持续' + "<div style='color: rgba(255, 113, 134, 1);'>" + item + "</div>" + '秒' + "</div>";
									} else {
										needStr = needStr + "<div style='display: flex; align-items: center'>" + "<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:10px;height:10px;background-color:rgba(185, 221, 255, 1);'></span>" + '第' + (i + 1) + '次持续' + "<div style='color: rgba(255, 113, 134, 1);'>" + item + "</div>" + '秒' + "</div>";
									}
								}
								return needStr;
								// return (
								// 	" 发生"
								// 	// apnea[params[0].dataIndex] +
								// 	// params.value
								// 	+
								// 	"<br/><div style='background-color:rgba(95, 100, 231, 1')>123</div>"
								// 	+
								// 	"1次呼吸暂停"
								// 	// "1次呼吸暂停"
								// 	// +
								// 	// "<br/><span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:10px;height:10px;background-color:rgba(95, 100, 231, 1)'></span>"
								// 	// +
								// 	// needStr2
								// 	+
								// 	"<br/><div style='background-color:rgba(95, 100, 231, 1')>123</div>"
								// 	+
								// 	tempArr[1][1].duration
								// );
							} else {
								// return params[0].axisValue;
							}
						},
					},
					grid: {
						left: "1%",
						right: "2%",
						top: "8%",
						bottom: "0%",
						containLabel: true,
					},
					color: ["#1890FF"],
					xAxis: [
						{
							type: "category",
							// max: this.leaveBedTime != '暂无' ? this.leaveBedTime : this.endTime,
							// min: this.getBedTime != '暂无' ? this.getBedTime : this.beginTime,

							axisTick: {
								//y轴刻度线
								show: false,
							},
							axisLabel: {
								//x坐标轴刻度标签
								textStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
								interval: 119,
							},
							axisLine: {
								//x坐标轴轴线
								lineStyle: {
									color: "#9094A6",
									type: "solid",
								},
							},
							// data: this.minutes,
							data: data.xAxis.data,
						},
					],
					yAxis: [
						{
							type: "value",
							// max: 2,
							// min: 2,
							axisLine: {
								//坐标轴轴线相关设置。
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
								show: false,
							},
							splitLine: {
								//坐标轴在 grid 区域中的分隔线设置。
								show: true,
								lineStyle: {
									type: "dashed",
									color: [
										"transparent",
										"#fff",
										"#ddd",
										"#fff",
										"#fff",
										"#fff",
									],
								},
							},
							axisTick: {
								//坐标轴刻度相关设置
								//y轴刻度线
								show: false,
							},
							axisLabel: {
								//坐标轴刻度标签的相关设置。
								formatter: function (value) {
									var texts = [];
									if (value == 1) {
										let words = "呼吸" + "\n" + "暂停";
										// let words = '呼吸暂停'
										texts.push(words);
									}
									return texts;
								},
								textStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
								show: true,
							},
						},
					],
					series: [
						{
							// data: apneaOnes,
							// data: [
							//   0,
							//   0,
							//   0,
							//   1,
							//   1,
							//   1,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   2,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							//   0,
							// ],
							data: data.series.data,
							type: "bar",
							showBackground: true,
							backgroundStyle: {
								color: "rgba(0,0,0,0)",
							},
						},
					],
				};
				console.log(option2);
				this.myChartAHI.setOption(option2);
			});
		},

		// 吸呼比柱状图透明度
		getBarMaxAlphaArr(arr) {
			// 从小到大
			// let arr[] = [1, 2, 3, 4, 5, 5, 6, 7, 4, 3, 2, 1, 1, 1, , 1, 1, 1, 1, '-', 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

			// 将undefined、-、''转为0的有效数组
			let targetArr = [];
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] && arr[i] != "" && arr[i] != "-" && arr[i] != 0) {
					targetArr.push(arr[i]);
				} else {
					targetArr.push(0);
				}
			}

			// 数组去重
			let duplicateRemovalArr = [
				...new Set(JSON.parse(JSON.stringify(targetArr))),
			];

			// 有效柱子个数
			let effective = 0;
			for (let i = 0; i < duplicateRemovalArr.length; i++) {
				effective++;
			}

			// 递减透明度
			let differenceAlpha = 0.15;
			if (effective > 15) {
				differenceAlpha = 0.1;
			}

			// 数组排序
			let sortArr = JSON.parse(JSON.stringify(duplicateRemovalArr)).sort(
				function (a, b) {
					return a - b; // 升序
				}
			);

			// 数组倒序
			let reverseArr = sortArr.reverse();

			// 透明度字典对标
			let alphaDict = {};
			for (let i = 0; i < reverseArr.length; i++) {
				let value = String(reverseArr[i]);
				alphaDict[value] = Number((1 - i * differenceAlpha).toFixed(2));
				if (1 - i * differenceAlpha < 0.2) {
					alphaDict[value] = 0.2;
				}
			}

			let alphaArr = [];
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] && arr[i] != "" && arr[i] != "-" && arr[i] != 0) {
					alphaArr.push(alphaDict[arr[i]]);
				} else {
					alphaArr.push(0.2);
				}
			}
			return alphaArr;
		},

		// 典型呼吸异常事件图
		get_dxycThing(idName, series_data) {
			this.$nextTick(() => {
				this.myChart_dxyc = this.$echarts.init(document.getElementById(idName));
				let option = {
					tooltip: {
						show: true,

						trigger: "axis",
						backgroundColor: "rgba(255, 255, 255, 0.9)",
						borderColor: "rgba(24, 144, 255, 0.8)",
						borderWidth: 1,
						spanStyle: {
							color: "#fff",
						},
						confine: true,
						borderRadius: 5,
						formatter: function (params) {
							// console.log(params);
							// let newName = params[0].name.replace('-','月') + '日'
							// if (type == 'bjbl') {      //报警比例
							return (
								// params[0].name +
								// newName +
								// '\n' +
								params[0].marker + params[0].data
							);
							// }
						},
					},
					grid: {
						x: 0,
						y: 0,
						x2: 0,
						y2: 0,
					},
					xAxis: {
						type: "category",
						show: false,
					},
					yAxis: {
						type: "value",
						show: false,
					},
					series: [
						{
							data: series_data,
							type: "line",
							smooth: true,
							symbolSize: 0,
							itemStyle: {
								// color: 'rgba(4, 209, 240, 1)'
								color: "#1890FF",
							},
							lineStyle: {
								width: 1,
							},
						},
					],
				};
				this.myChart_dxyc.setOption(option);
			});
		},
	},
};
</script>

<style lang="scss">
.comment {
	width: 100%;
	height: 220px;
	box-sizing: border-box;
	display: flex;
	justify-content: flex-start;
}

.comment-details {
	width: 100%;
	margin-top: 8px;
	column-count: 2;
	column-gap: 10px;

	.comment-details-item {
		break-inside: avoid;
		margin-bottom: 10px;

		.comment-details-item-box {
			width: 100%;
			height: 100%;
			padding: 16px 12px;
			background: #fff;

			.details-title {
				display: flex;
				align-items: center;
				font-size: 20px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #1f2635;

				.details-title-icon img {
					width: 20px;
					height: 20px;
					margin-right: 4px;
					position: relative;
					top: -2px;
				}

				.details-title-num {
					color: #ff7186;
				}
			}

			.details-title-breath {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.ml24 {
				margin-left: 24px;
			}

			.details-consult {
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #9094a6;
			}

			.detailed-inter {
				background: #f3f4f7;
				border-radius: 2px;
				padding: 12px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #9094a6;
				margin-top: 4px;
				overflow: hidden;

				.detailstr-circle::before {
					content: "";
					display: inline-block;
					width: 3px;
					height: 3px;
					border-radius: 50%;
					background: #9094a6;
					position: relative;
					top: -4px;
				}

				.advice-item {
					display: flex;
					align-items: center;
					margin: 5px 0;
				}

				.advice-item img {
					width: 34px;
					height: 34px;
					margin-right: 5px;
				}

				.detailed-inter-line {
					width: 100%;
					height: 1px;
					border: 1px solid #e8eaed;
					margin: 12px 0;
				}

				.detailed-inter-title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					overflow: hidden;
				}

				.detailed-inter-title img {
					width: 14px;
					height: 14px;
				}
			}

			.breath-thing {
				display: flex;
				align-items: center;
				flex-direction: column;
				background: #f3f4f7;
				margin-top: 10px;
				padding: 8px 0;
			}

			.breath-thing-title {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-around;

				div {
					flex: 1;
					text-align: center;
				}
			}

			.detailed-inter-line {
				width: 100%;
				height: 1px;
				border: 1px solid #e8eaed;
				margin: 12px 0;
			}
		}
	}

	.breath-title {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.breath-title-left {
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #1f2635;
		}

		.breath-title-right {
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #a5a9bc;
			display: flex;
			align-items: center;

			img {
				width: 20px;
				height: 20px;
				margin-left: 4px;
			}
		}
	}

	.dxhxEvent {
		.dxlbWrap {
			margin-top: 5px;
			position: relative;

			.imgWrap {
				width: 95%;
				height: 75px;
				margin-left: 10px;
				overflow: hidden;
				border: 1px solid rgba(24, 144, 255, 0.1);

				.img {
					width: 125%;
					height: 100%;
					margin-left: -50px;
				}
			}

			.btnWrap {
				width: 100%;
				height: 40px;
				position: absolute;
				left: 0;
				top: 47px;
			}

			.num {
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #a5a9bc;
			}

			.left-btn-abn,
			.right-btn-abn {
				position: absolute;
				top: 0;
				z-index: 10;
				width: 40px;
				display: inline-block;

				img {
					width: 40px;
				}
			}

			.left-btn-abn {
				left: -10px;
			}

			.right-btn-abn {
				right: -10px;
			}

			.left-btn-abn,
			.right-btn-abn:hover {
				cursor: pointer;
			}
		}
	}
}

.draw_canvas-title {
	// display: flex;
	// align-items: center;
	// justify-content: space-between;
	// flex-wrap: wrap;

	.draw_canvas-title-item {
		width: 20%;
		display: flex;
		align-items: center;
		// justify-content: center;
		margin-bottom: 12px;
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #9094a6;
		float: left;

		.title-item-pic {
			width: 20px;
			height: 20px;
			margin-right: 2px;
			background: #fff;
			border: 3px solid #ff7186;
			border-radius: 50%;
		}

		.active-flag-pic {
			background: #ff7186;
		}
	}
}

/* 柱状图 */
.colPicWrap {
	width: 100%;
	height: auto;
	/* background: #F5F5F5; */
	border-radius: 8px;
	padding: 0;
	position: relative;
	left: -0;
}

.colPicWrap .colTop {
	display: flex;
	align-items: center;
	padding: 0;
	box-sizing: border-box;
}

.colPicWrap .colTop .topIcon {
	width: 16px;
	height: 5px;
	background: #f6f9fe;
	border: 1px dashed #1890ff;
}

.colPicWrap .colTop .topTit {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #1890ff;
	margin-left: 8px;
}

.colChartWrap {
	height: 190px;
}

.colPicWrap .colChart {
	width: 320px;
	height: 160px;
	border-bottom: 1px solid #9094a6;
	position: relative;
	left: 50px;
	top: 20px;
}

.colPicWrap .colChart .posAb_X {
	width: 100%;
	display: flex;
	position: absolute;
	left: 0;
	bottom: -25px;
}

.colPicWrap .colChart .posAb_X .num {
	font-size: 10px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #a5a9bc;
	margin-left: 50px;
}

.colPicWrap .colChart .posAb_X .num:nth-of-type(1) {
	margin-left: 5px;
}

.colPicWrap .colChart .posAb_Y {
	height: 155px;
	display: flex;
	flex-direction: column-reverse;
	text-align: right;
	position: absolute;
	left: -33px;
	bottom: -10px;
}

.colPicWrap .colChart .posAb_Y .num {
	display: flex;
	align-items: center;
	font-size: 10px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #a5a9bc;
	margin-bottom: 20px;
}

.colPicWrap .colChart .posAb_Y .num:nth-of-type(1) {
	margin-bottom: 0;
}

.colPicWrap .colChart .posAb_Green {
	width: 93px;
	height: 155px;
	/* background: #EDFFF0;
  background: rgba(237, 255, 240, 1); */

	background: rgba(77, 142, 247, 0.05);
	border: 1px dashed #4d8ef7;
	border-bottom: 0;
	position: absolute;
	left: 107px;
	bottom: 0;
}

.colPicWrap .colChart .posAb_cont {
	width: 320px;
	height: 160px;
	position: absolute;
	left: 0;
	bottom: 0;

	// 浮窗
	.handFloat {
		position: absolute;
		left: 20px;
		top: 0;
		padding: 8px;
		border: 1px solid rgba(24, 144, 255, 0.6);
		border-radius: 4px;
		background: #fff;

		.wzCir {
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: #2e90ff;
			margin-right: 4px;
		}
	}
}

.colPicWrap .colChart .posAb_cont .cList {
	width: 12px;
	height: 40px;
	border-radius: 8px 8px 0px 0px;
	margin-left: 2px;
	float: left;
	position: absolute;
	bottom: 0;
	// background: linear-gradient(360deg, #b84df7 0%, #c394fe 100%);
	border-radius: 4px 4px 0px 0px;
}

.in_cList {
	width: 100%;
	height: 100%;
	border-radius: 8px 8px 0px 0px;
}

.bgB67FFA_D2B1FC {
	background: linear-gradient(360deg, #b67ffa 0%, #d2b1fc 100%);
}

.bg7AAEFC_C8B2FF {
	background: linear-gradient(360deg, #7aaefc 0%, #c8b2ff 100%);
}

.colPicWrap .tips {
	width: 670px;
	height: auto;
	font-size: 28px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #262626;
	margin: 20px auto 0;
}

.noVal {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
}

.AHI-position {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);

	z-index: 100;

	.AHI-position-dom {
		width: 1100px;
		position: fixed;
		top: 50%;
		left: 50%;
		padding: 24px;
		transform: translate(-50%, -50%);
		background: #fff;
	}
}

.comment-box {
	.tooltip {
		height: 34px;
		margin-left: 5px;
		position: relative;
		display: inline-block;
		border-bottom: 1px dotted #fff;
	}

	.tooltip .tooltiptext {
		visibility: hidden;
		width: 375px;
		background: #ffffff;
		box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
		border-radius: 8px;
		color: #ccc;
		border-radius: 6px;
		padding: 20px 20px;

		/* 定位 */
		position: absolute;
		z-index: 1;
		top: -5px;
		left: 105%;
	}

	.tooltip .tooltiptext {
		top: -240px;
		left: -182px;
	}

	.tooltip:hover .tooltiptext {
		visibility: visible;
	}

	.tooltip .tooltiptext::after {
		content: "";
		position: absolute;
		top: 100%;
		left: 50%;
		margin-left: -5px;
		border-width: 8px;
		border-style: solid;
		border-color: white transparent transparent transparent;
	}

	.ahi-title {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1f2635;
	}

	.ahi-title::before {
		content: "";
		display: inline-block;
		width: 3px;
		height: 18px;
		background: #4d8ef7;
		border-radius: 2px;
		position: absolute;
		top: 21px;
		left: 0;
	}

	.ahi-item {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5e6779;
		margin: 10px 0;
	}

	.ahi-item::before {
		content: "";
		display: inline-block;
		width: 8px;
		height: 8px;
		background: #4d8ef7;
		border-radius: 50%;
		margin-right: 8px;
	}

	.ahi-item2::before {
		background: #ffc471;
	}

	.ahi-item3::before {
		background: #ff7186;

	}
}
</style>
